import { Component, Input } from '@angular/core';

import { messageSeverityEnum } from '../../../Misc/enums/message-severity.enum';

export enum MentionTypeEnum {
    SOCIAL = 'Social',
    MONITORING = 'Monitoring',
}

@Component({
    selector: 'agpr-unsaved-export-info-message',
    templateUrl: './unsaved-export-info-message.component.html',
    standalone: false
})
export class UnsavedExportInfoMessageComponent {
    @Input() mentionCount: number;
    @Input() unsavedMentionExportLimit: number;
    @Input() unsavedMentionQuotaUsage: number;
    @Input() remainingUnsavedMentionQuota: number;
    @Input() mentionType: MentionTypeEnum;

    readonly messageSeverities = messageSeverityEnum;

    constructor() {}
}
